import { computed } from "vue";
import { useProgramDomains } from "./useProgramDomains";
const selectPreviewProgramDomain = (programDomains) => {
    let selected = programDomains.find((programDomain) => {
        return (programDomain.is_extole_domain &&
            programDomain.redirect_program_id === null);
    });
    if (!selected) {
        selected = programDomains.find((programDomain) => {
            return programDomain.redirect_program_id === null;
        });
    }
    return selected;
};
export const usePreviewProgramDomain = () => {
    const { programDomains } = useProgramDomains();
    const previewProgramDomain = computed(() => {
        return selectPreviewProgramDomain(programDomains.value);
    });
    return {
        previewProgramDomain,
    };
};
